import Action from "csi/def/Action";
import { Field } from "csi/def/Field";
import Relationship from "csi/def/Relationship";
import ViewRef from "csi/def/ViewRef";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import NewFromBOMFormMixin from "./NewFromBOMFormMixin";

// Fields
const RECIPE = "Recipe";
const FOOD_BOM = "FoodBOM";

// Views
const RECIPE_VIEW = "FoodSKURecipes";
const FOOD_BOM_VIEW = "FoodSKUBOMs";

const NewFromBOMSKULabelDataSheetsFormMixin = declare(NewFromBOMFormMixin, {

	 /**
	 * @override
	 * Use FoodSKU's url for querying BOM dropdown
	 */
	getFieldStore(field: Field, value: any) {
		if (field.m_id === RECIPE || field.m_id === FOOD_BOM) {
			const ctx = this.getContext();
			const foodSKUUrl = this.defView.getSource().m_urlParent;

			// create relationship for Recipe dropdown
			const rel = lang.mixin(new Relationship(), {
				m_typeNode: this.bomType,
				m_query: new Query().RefAttr(
					this._isFoodBOM ? "FoodBOMSKUs" : "RecipeSKUs", 
					xml.OP_EQUALS, 
					foodSKUUrl,
				),
			});

			const store = ctx.view.createHeadingNamesStore(ctx, field, null, rel);

			// create view for goto dialog
			store.action = lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: this._isFoodBOM ? FOOD_BOM_VIEW : RECIPE_VIEW,
					m_url: foodSKUUrl,
				}),
			});
			return store;
		} else {
			return this.inherited(arguments);
		}
	},
});

export = NewFromBOMSKULabelDataSheetsFormMixin;